import { FC } from 'react';
import * as vp from 'vopay';
import AccountingSoftwareLayout from '../AccountingSoftwareLayout/AccountingSoftwareLayout';
import styles from './ConnectionSoftware.module.scss';
import { connectSoftwareImageMap } from './ConnectSoftwareImageMap';
import { useTranslation } from 'react-i18next';

type ConnectSoftwareProps = {
  onConnect: () => void;
};
const { Box, Title, SubTitle, Button } = vp;

const ConnectSoftware: FC<ConnectSoftwareProps> = ({ onConnect }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.AccountingSystem.AccountingSoftware.Connect' });

  return (
    <AccountingSoftwareLayout
      leftContent={
        <div className={styles.leftContainer}>
          <Box flx="col" base="8" gap="lg">
            <Title title={t('title', { defaultValue: 'Accounting Data Integration' })} />
            <p className={styles.connectionParagraph}>
              {t('description', {
                defaultValue:
                  'VoPay integrates with your accounting system by providing the option to import your A/R and A/P data into VoPay or by embedding VoPay payment rails into your accounting system. Your integration options are shown below.',
              })}
            </p>
            <SubTitle subTitle={t('subTitle', { defaultValue: 'Import Your Accounting Data into VoPay' })} />
            <p className={styles.connectionParagraph}>
              {t('subDescription', {
                defaultValue:
                  'Use this option to import your A/R and A/P data into VoPay Portal so you can collect invoices and pay bills from VoPay Portal’s dashboard. Accounting systems supported include Dynamics 365 Business Central, FreshBooks, Oracle NetSuite, QuickBooks Online, QuickBooks Desktop, Sage Business Cloud, Sage Intacct, Xero, and Wave.',
              })}
            </p>
          </Box>
        </div>
      }
      rightContent={
        <div className={styles.rightContainer}>
          <Box base="8" gap="ml" flx="col">
            <Box>{t('stepsTitle', { defaultValue: 'There are 2 steps to connect your accounting system' })}</Box>

            <Box base="5" gap="md" flx="col">
              <Box base="8" gap="ml" flx="row">
                <img
                  className={styles.img}
                  src={connectSoftwareImageMap.computerCheck.src}
                  alt={connectSoftwareImageMap.computerCheck.alt || ''}
                />

                <Box flx="col" jc="center">
                  <h3 className={[styles.connectionParagraph, styles.bold].join(' ')}>
                    {t('stepOne', { defaultValue: 'Step 1' })}
                  </h3>
                  <p className={styles.connectionParagraph}>
                    {t('stepOneDescription', { defaultValue: 'Select your accounting software' })}
                  </p>
                </Box>
              </Box>

              <Box base="8" gap="ml" flx="row">
                <img
                  className={styles.img}
                  src={connectSoftwareImageMap.computerList.src}
                  alt={connectSoftwareImageMap.computerList.alt || ''}
                />

                <Box flx="col" jc="center">
                  <h3 className={[styles.connectionParagraph, styles.bold].join(' ')}>
                    {t('stepTwo', { defaultValue: 'Step 2' })}
                  </h3>
                  <p className={styles.connectionParagraph}>
                    {t('stepTwoDescription', { defaultValue: 'Select your chart of accounts' })}
                  </p>
                </Box>
              </Box>
            </Box>
          </Box>
        </div>
      }
      bottomRow={
        <Box flx="row" jc="fe">
          <Button
            id="connect-accounting-software-btn"
            height="36px"
            onClick={onConnect}
            label={t('connectButton', { defaultValue: 'Connect Accounting System' })}
          />
        </Box>
      }
    />
  );
};

export default ConnectSoftware;
